module.exports = __webpack_public_path__ + "1c9922b4b6719237270e99872ad9e8c4.png";